module.exports = __webpack_public_path__ + "static/media/list.6360ff4d.svg";